<template lang="pug">
  .page.is-wide
    main
      h1.headline.page_headline ページが見つかりません
</template>

<script>
  export default {
    title: 'Not Found',
    description: ''
  }
</script>



// WEBPACK FOOTER //
// PageNotFound.vue?72251086